"use client";

import { MetricCard } from "./MetricCard";
import { DollarSign, Calendar, Users, RefreshCw } from "lucide-react";
import { formatCurrency } from "@/lib/utils";
import { TodayRevenue } from "@/services/dashboardService";

interface MetricsGridProps {
  todayRevenue: TodayRevenue | null;
  todayAppointments: number;
  todayStats: Record<string, number>;
  totalCustomers: number;
  vehiclesCount: number;
  activeSubscriptions: number;
}

export function MetricsGrid({
  todayRevenue,
  todayAppointments,
  todayStats,
  totalCustomers,
  vehiclesCount,
  activeSubscriptions,
}: MetricsGridProps) {
  const revenueValue = formatCurrency(todayRevenue?.collected || 0);

  return (
    <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4">
      <MetricCard
        title="Today's Revenue"
        value={revenueValue}
        subtitle={`${todayAppointments} appointments`}
        icon={DollarSign}
        iconBgColor="bg-emerald-50"
        iconColor="text-emerald-600"
      />
      <MetricCard
        title="Appointments"
        value={todayAppointments}
        subtitle={`${todayStats.scheduled || 0} scheduled today`}
        trend="+12.5%"
        trendColor="text-blue-600"
        icon={Calendar}
        iconBgColor="bg-blue-50"
        iconColor="text-blue-600"
      />
      <MetricCard
        title="Total Customers"
        value={totalCustomers}
        subtitle={`${vehiclesCount} vehicles`}
        trend="+8.2%"
        trendColor="text-purple-600"
        icon={Users}
        iconBgColor="bg-purple-50"
        iconColor="text-purple-600"
      />
      <MetricCard
        title="Active Subscriptions"
        value={activeSubscriptions}
        subtitle="Recurring customers"
        trend="Active"
        trendColor="text-indigo-600"
        icon={RefreshCw}
        iconBgColor="bg-indigo-50"
        iconColor="text-indigo-600"
      />
    </div>
  );
}
